import type { TextResult } from '@core-api/presentation/types/response';
import type { SlidePreviewResultsInputs } from '../../types';

const WORD_CLOUD_TEXTS = [
  { text: 'creative', count: 8 },
  { text: 'bold', count: 3 },
  { text: 'fast', count: 8 },
  { text: 'inspiration', count: 1 },
  { text: 'transpiration', count: 2 },
  { text: 'leader', count: 5 },
  { text: 'focus', count: 4 },
  { text: 'leadership', count: 2 },
  { text: 'quick', count: 3 },
  { text: 'inspirational', count: 2 },
  { text: 'inspire', count: 3 },
  { text: 'top', count: 2 },
  { text: 'quality', count: 5 },
  { text: 'sharing', count: 2 },
  { text: 'leading', count: 2 },
  { text: 'integration', count: 2 },
  { text: 'innovative', count: 1 },
  { text: 'performance', count: 1 },
  { text: 'innovation', count: 1 },
  { text: 'transformers', count: 1 },
  { text: 'change', count: 1 },
];

export const getPreviewResultsIteration = ({
  previous = [],
  iteration,
}: SlidePreviewResultsInputs<TextResult>): TextResult[] => {
  if (iteration === 0) return [];

  const next = WORD_CLOUD_TEXTS[iteration - 1];
  return next
    ? [...previous, { responseText: next.text, responseCount: next.count }]
    : previous;
};
